export default __webpack_public_path__ + "static/media/arrow-right.7f45b1e0.svg";